export enum ToggleKeyType {
  alpha = 'Alpha',
  numeric = 'Numeric',
}

export enum AlphaCollection {
  spaceAlpha = 'SpaceAlpha',
  a = 'a',
  b = 'b',
  c = 'c',
  d = 'd',
  e = 'e',
  f = 'f',
  g = 'g',
  h = 'h',
  i = 'i',
  j = 'j',
  k = 'k',
  l = 'l',
  m = 'm',
  n = 'n',
  o = 'o',
  p = 'p',
  q = 'q',
  r = 'r',
  s = 's',
  t = 't',
  u = 'u',
  v = 'v',
  w = 'w',
  x = 'x',
  y = 'y',
  z = 'z',
  deleteAlpha = 'DeleteAlpha',
}

export enum NumericCollection {
  spaceNumeric = 'SpaceNumeric',
  one = '1',
  two = '2',
  three = '3',
  four = '4',
  five = '5',
  six = '6',
  seven = '7',
  eight = '8',
  nine = '9',
  zero = '0',
  deleteNumeric = 'DeleteNumeric',
}

export type SearchScreenProps = {
  onReadyToExit: (isReady: boolean) => void
}

export type KeyboardTogglerProps = {
  onEnterPress: (arg0: ToggleKeyType) => void
}

export type KeyboardProps = {
  onArrowPress: (direction: string, p: { index: number }) => boolean
  onEnterPress: (keyString: AlphaCollection | NumericCollection) => void
}

export type KeyboardKeysProps = {
  keyboardToggleKey: ToggleKeyType
  onEnterPress: (extraProps: {
    keyString: AlphaCollection | NumericCollection
  }) => void
  onArrowPress: (direction: string, p: { index: number }) => boolean
}

export type KeyTogglerProperties = {
  keyToggler: ToggleKeyType
  keyLabel: string
  keyTTS: string
}
